import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum SortDirection {
  ASCENDING = 'ascending',
  DESCENDING = 'descending'
}
export enum SortableColumn {
  ORT = 'ort',
  DAUER = 'dauer',
  BEGINN = 'beginn',
  UNTERRICHTS_FORM = 'unterrichtsform',
  UNTERRICHTS_ZEIT = 'unterrichtszeit',
  KOSTEN = 'kosten'
}

@Injectable({
  providedIn: 'root'
})
export class TerminTabelleSortingService {
  private readonly _sortDirection$ = new BehaviorSubject<SortDirection>(SortDirection.ASCENDING);
  private readonly _sortColumn$ = new BehaviorSubject<SortableColumn>(SortableColumn.BEGINN);

  public sortDirection$ = this._sortDirection$.asObservable();
  public sortColumn$ = this._sortColumn$.asObservable();

  public setSortDirection = (sortDirection: SortDirection): void => {
    this._sortDirection$.next(sortDirection);
  };

  public setSortColumn = (sortColumn: SortableColumn): void => {
    this._sortColumn$.next(sortColumn);
  };

  public getSortDirection = (): SortDirection => {
    return this._sortDirection$.getValue();
  };

  public getSortColumn = (): SortableColumn => {
    return this._sortColumn$.getValue();
  };
}
